module.exports = __webpack_public_path__ + "assets/img/fashion-img6-dabcb1f5.png";